export const REQUIRED_FIELD = 'Requerido';

export const MIN = 'Mínimo';

export const MAX = 'Máximo';
